import React from "react";
import { Row, Col } from "reactstrap";
import { SchedulingProvider } from "../../../providers/schedulingProvider";
import Scheduling from "./inProjectManagement/Scheduling";
import PreProductionSummary from "./inProjectManagement/PreProductionSummary";
import ManHoursChart from "./inProjectManagement/ManHoursChart";
import JobDetailsSummary from "./JobDetailsSummary";
import DetailingSummary from "./inProjectManagement/DetailingSummary";
import ProgrammingSummary from "./inProjectManagement/ProgrammingSummary";
import ProjectDetailsSummary from "./inProjectManagement/ProjectDetailsSummary";

const InPMContent = () => {
  return (
    <>
      <Row>
        <Col sm="4">
          <SchedulingProvider>
            <Scheduling />
          </SchedulingProvider>
        </Col>
        <Col sm="3" className="p-0">
          <PreProductionSummary />
        </Col>
        <Col sm="5">
          <ManHoursChart />
        </Col>
      </Row>
      <Row className="my-3">
        <Col sm="3">
          <JobDetailsSummary />
        </Col>
        <Col sm="3" className="p-0">
          <DetailingSummary />
        </Col>
        <Col sm="3">
          <ProgrammingSummary />
        </Col>
        <Col sm="3" className="pl-0">
          <ProjectDetailsSummary />
        </Col>
      </Row>
    </>
  );
};

export default InPMContent;
